<script lang="ts">
  import { cn } from '$lib/utils';

  export let src: string;
  export let itemClass: string;
  export let active: boolean;
</script>

<div class="relative min-w-full h-full overflow-hidden bg-repeat">
  <video
    src={src + '#t=0.001'}
    preload="metadata"
    autoplay={true}
    loop
    muted
    playsinline
    class={cn('select-none', itemClass, !active && 'hidden', 'absolute inset-0')}
  />
</div>
